import { Link } from 'react-router'
import { Reveal, Section, SectionHeading } from '@/components/primitives'
import { NexExchange } from '@/components/visuals/NexExchange'

export function NexTeaser() {
  return (
    <Section labelledBy="nex-home-heading" className="bg-base-900/40">
      <Reveal>
        <SectionHeading
          id="nex-home-heading"
          eyebrow="Nex"
          eyebrowTone="nex"
          title="Intelligence inside the operation."
          copy="Nex answers from your world, accelerates the work, and keeps guardrails when it matters. Speed without giving away the keys."
        />
      </Reveal>

      <Reveal delay={80}>
        <ul className="mx-auto mt-8 flex max-w-3xl flex-col items-center gap-3 text-center">
          {[
            'Ask how anything works. Get answers with sources.',
            'Draft changes against live account context.',
            'You approve what goes live. The audit trail stays intact.',
          ].map((line) => (
            <li
              key={line}
              className="max-w-xl border-l-0 text-sm leading-relaxed text-ink-mute sm:border-l sm:border-nex/60 sm:pl-4 sm:text-left"
            >
              {line}
            </li>
          ))}
        </ul>
        <div className="mt-6 text-center">
          <Link to="/nex" className="btn-ghost px-0 text-nex-soft hover:text-nex">
            Explore Nex →
          </Link>
        </div>
      </Reveal>

      <Reveal delay={120}>
        <div className="mx-auto mt-10 max-w-3xl">
          <NexExchange />
        </div>
      </Reveal>
    </Section>
  )
}
